<!--
  @Description: 专题pro-收藏
  @Author: wang.y 
  @Date: 2022-02-23 
-->
<template>
  <div>
    <div class="commonlist">
      <div class="img-item" v-for="(item, index) in list" :key="item.id">
        <div class="img"  @click="$parent.goDetail(2, item.uid)">
          <img :src="item.share_logo_path | logo_show" class="logo" />
          <img :src="$store.state.static_img_url + 'pic/list/u-li-type-1.png'" class="u-li-type">
        </div>
        <div class="info">
          <div class="title over-p2"  @click="$parent.goDetail(2, item.uid)">{{item.title}}</div>
          <div class="summary over-p2">{{item.summary}}</div>
          <div class="dec">
            <div class="lt" v-if="item.latest_content && item.latest_content.length">
              <div class="last-updata">{{item.latest_content[0].publish_time | time_moment}}更新：{{item.latest_content[0].title}}</div>
            </div>
            <div class="collect_share">
              {{item.create_time}}
              <i class="iconfont collec-icon" @click="handleCancel('2', item.id, cancelCollectCb, index)" title="取消收藏">&#xe66f;</i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spin v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="more-btn" v-if="more && !loading">
      <div @click="handleMore('2')">加载更多</div>
    </div>
    <default-list v-if="!list.length && !loading">
      <template slot="p">
        <p>您目前没有收藏任何专题，不如去随便逛逛 <br />看看有什么内容值得收藏起来，反复品读 </p>
        <router-link :to="{ name: 'SpecialList' }">去专题列表看看</router-link>
      </template>
    </default-list>
  </div>
</template>
<script>
import DefaultList from './DefaultList'
import { collect_list } from 'js/collect_list'
export default {
  mixins: [collect_list],
  components: {
    DefaultList
  },
  created() {
    this.userFavorite('2')
  },
  mounted() { },
  data() {
    return {

    }
  },
  computed: {},
  methods: {

  }
}
</script>
<style lang="stylus" scoped></style>